<app-modal-header title="Filters" />

<app-modal-body>
  <div class="afs">
    @for (field of data.fields; track $index) {
      @switch (field.kind) {
        @case ('text') {
          <div class="afs__field">
            <label class="afs__label" [for]="'afs-' + field.key">{{ field.label }}</label>
            <input
              [id]="'afs-' + field.key"
              type="text"
              class="field-input"
              autocomplete="off"
              [placeholder]="field.placeholder ?? ''"
              [ngModel]="values[field.key]"
              (ngModelChange)="set(field.key, $event)"
            />
          </div>
        }
        @case ('segments') {
          <div class="afs__field">
            <span class="afs__label" [id]="'afs-' + field.key">{{ field.label }}</span>
            <div class="afs__segments" role="radiogroup" [attr.aria-labelledby]="'afs-' + field.key">
              @for (option of field.options; track option.value) {
                <button
                  type="button"
                  role="radio"
                  class="afs__segment"
                  [class.afs__segment--on]="values[field.key] === option.value"
                  [attr.aria-checked]="values[field.key] === option.value"
                  (click)="set(field.key, option.value)"
                >{{ option.label }}</button>
              }
            </div>
          </div>
        }
        @case ('dates') {
          <div class="afs__field">
            <span class="afs__label">{{ field.label }}</span>
            <div class="afs__dates">
              @for (side of [{ key: field.fromKey, title: 'From' }, { key: field.toKey, title: 'To' }]; track side.key) {
                @let value = values[side.key];
                <div
                  class="field-input field-input--date"
                  role="button"
                  tabindex="0"
                  [attr.aria-label]="side.title + ' date'"
                  (click)="pickDate(side.key, side.title)"
                  (keydown.enter)="pickDate(side.key, side.title)"
                >
                  <svg class="field-input__icon" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M5 1.5C5 1.22386 5.22386 1 5.5 1C5.77614 1 6 1.22386 6 1.5V2H10V1.5C10 1.22386 10.2239 1 10.5 1C10.7761 1 11 1.22386 11 1.5V2H12C12.5523 2 13 2.44772 13 3V13C13 13.5523 12.5523 14 12 14H4C3.44772 14 3 13.5523 3 13V3C3 2.44772 3.44772 2 4 2H5V1.5ZM4 5V13H12V5H4Z" fill="currentColor"/></svg>
                  <span class="form-hint">{{ formatIsoDate(value) || side.title }}</span>
                  @if (value) {
                    <button type="button" class="field-input__clear" [attr.aria-label]="'Clear ' + side.title.toLowerCase() + ' date'" (click)="clearDate(side.key, $event)">
                      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </button>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
    }
  </div>
</app-modal-body>

<app-modal-footer>
  <button type="button" class="btn--secondary" [disabled]="!changed" (click)="reset()">Reset</button>
  <button type="button" class="btn--primary" (click)="apply()">Show results</button>
</app-modal-footer>
